/* Block - Logo Band.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-logo-band.scss";
import rsCarousel from '../../js/component/_carousel';

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-logo-band'));

rsCarousel.init(carousels);
